import type {
  CatalogDocumentDTO,
  ReferenceType as WireReferenceType,
} from '@/shared/api'

export type ReferenceListStatus = 'idle' | 'loading' | 'ready' | 'error'

export interface ReferenceListState {
  documents: CatalogDocumentDTO[]
  status: ReferenceListStatus
  error: string | null
}

export interface ReferenceUploadSuccessSummary {
  document_id: string
  filename: string
  chunks_indexed: number
  /** True when the upload reindexed an existing document_id under the same tenant. */
  replaced: boolean
  /** Phase 3B — 'queued' when enqueued for the background worker, else 'indexed'. */
  status?: 'indexed' | 'queued'
  job_id?: string | null
}

/**
 * Tipos canônicos da Biblioteca de Referência — espelha o ``ReferenceType``
 * do backend. Mantidos como ``readonly`` para que o ``ReferenceTypeOption``
 * sirva de fonte única para a UI (select, label, descrição).
 */
export interface ReferenceTypeOption {
  value: WireReferenceType
  label: string
  description: string
}

export const REFERENCE_TYPE_OPTIONS: readonly ReferenceTypeOption[] = [
  {
    value: 'protocol',
    label: 'Protocolo',
    description: 'Procedimento clínico, técnico ou operacional padrão.',
  },
  {
    value: 'legislation',
    label: 'Legislação',
    description: 'Leis, decretos, resoluções e normas oficiais.',
  },
  {
    value: 'guideline',
    label: 'Diretriz',
    description: 'Guias clínicos, jurídicos ou regulatórios.',
  },
  {
    value: 'policy',
    label: 'Política',
    description: 'Política interna da organização.',
  },
  {
    value: 'manual',
    label: 'Manual',
    description: 'Manuais técnicos, operacionais ou de uso.',
  },
  {
    value: 'sop',
    label: 'SOP',
    description: 'Standard Operating Procedure — POP interno.',
  },
  {
    value: 'internal_kb',
    label: 'Base interna',
    description: 'Base de conhecimento interna do workspace.',
  },
  {
    value: 'other',
    label: 'Outro',
    description: 'Documento de referência fora das categorias acima.',
  },
]

export interface ReferenceUploadFormValues {
  file: File | null
  documentId: string
  title: string
  referenceType: WireReferenceType | ''
  referenceDomain: string
  referenceYear: string
  referenceSource: string
}

export interface ReferenceUploadFormErrors {
  file?: string
  documentId?: string
  title?: string
  referenceType?: string
  referenceDomain?: string
  referenceYear?: string
  referenceSource?: string
  /** Top-level error from the API or aggregate validation. */
  form?: string
}
